import { useGetReportQuery } from "@modules/dashboard/queries";

export function useDashboard() {
  const { data, isLoading } = useGetReportQuery();

  return {
    data,
    isLoading,
  };
}
